import Phaser from 'phaser';
import { buildTextures } from '../textures.js';

export class BootScene extends Phaser.Scene {
  constructor() { super('Boot'); }

  create() {
    buildTextures(this);
    const splash = document.getElementById('boot-fallback');
    if (splash) splash.style.display = 'none';
    // Dev affordance: ?scene=Game/Shop/Menu/etc.
    const next = new URLSearchParams(location.search).get('scene') || 'Menu';
    this.scene.start(next);
  }
}
